import { Component, State, Vue, Prop as prop} from 'nuxt-property-decorator';
import { showFlash } from '~/lib/flash';
import { ICartActiveCoupon, ICartDisplaySuggestCoupon } from '~/types/cart';

@Component({
    components: {

    },
})
export default class CouponItemComponent extends Vue {

    @State('coupons/active') activeCoupon: ICartActiveCoupon | null;
    @prop()
    public coupon: ICartDisplaySuggestCoupon;

    public loading = false;

    public async copyCoupon(code: string) {
        navigator.clipboard.writeText(code);
        showFlash({text: 'Промокод скопирован', type: 'alert', timeout: 1500});
    }
}
